import { render, staticRenderFns } from "./BtnAtualizarDetalheParcelaFixa.vue?vue&type=template&id=20b37228"
import script from "./BtnAtualizarDetalheParcelaFixa.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarDetalheParcelaFixa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports